import { env } from 'core/utils';

export default (text: string) => {
  const pattern = `.*${text}.*`;

  // https://github.com/pouchdb/pouchdb-server/issues/445
  if (env.POUCHDB_SOURCE === 'local') {
    return RegExp(pattern, 'i');
  }

  return pattern;
};
